'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _hexToRgb2 = require('ui-addon-conversations/utils/hexToRgb');

var _hexToRgb3 = _interopRequireDefault(_hexToRgb2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECONDARY = 'secondary';

function getBackgroundColor(use, coloring, hovered) {
  var accentColor = coloring.accentColor;

  var _hexToRgb = (0, _hexToRgb3.default)(accentColor),
      r = _hexToRgb.r,
      g = _hexToRgb.g,
      b = _hexToRgb.b;

  if (use === SECONDARY) {
    if (hovered) {
      return 'rgba(' + r + ',' + g + ',' + b + ', 0.15)';
    }

    return undefined;
  }

  if (hovered) {
    return 'rgba(' + r + ',' + g + ',' + b + ', 0.85)';
  }

  return 'rgba(' + r + ',' + g + ',' + b + ', 1)';
}

function makeStyles(use, coloring, hovered) {
  var accentColor = coloring.accentColor,
      textColor = coloring.textColor;


  return {
    width: 'auto',
    height: 36,
    borderColor: accentColor,
    backgroundColor: getBackgroundColor(use, coloring, hovered),
    color: use === SECONDARY ? accentColor : textColor
  };
}

var QuickReply = _react2.default.createClass({
  displayName: 'QuickReply',

  propTypes: {
    onClick: _react.PropTypes.func.isRequired,
    use: _react.PropTypes.string.isRequired,
    disabled: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node.isRequired,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      use: SECONDARY,
      disabled: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      hovered: false
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    this.setState({ hovered: true });
  },
  handleMouseLeave: function handleMouseLeave() {
    this.setState({ hovered: false });
  },
  render: function render() {
    var _props = this.props,
        onClick = _props.onClick,
        children = _props.children,
        disabled = _props.disabled,
        use = _props.use,
        coloring = _props.coloring;
    var hovered = this.state.hovered;


    var styles = makeStyles(use, coloring, hovered);

    return _react2.default.createElement(
      _UIButton2.default,
      {
        className: 'quick-reply display-inline-flex m-top-0 m-bottom-2 m-right-2',
        style: styles,
        size: 'small',
        use: use,
        onClick: onClick,
        disabled: disabled,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      },
      children
    );
  }
});

exports.default = QuickReply;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/QuickReply.js
// module id = 402
// module chunks = 0 1